import { definePreset } from "@primeuix/themes";
import Material from "@primeuix/themes/material";

export const AMMSAS_PRESET = definePreset(Material, {
    primitive: {
        carbon: {
            50: '#DFDFE2',
            100: '#E3E4E8',
            200: '#D1D3D6',
            300: '#A9ADB1',
            400: '#979DA1',
            500: '#747E81',
            600: '#414848',
            700: '#1F2322',
            800: '#000000',
            900: '#131B17',
            950: '#131614'
        },
        soil: {
            50: '#DCE0CC',
            100: '#DBDECF',
            200: '#D6D6D1',
            300: '#B1B0A9',
            400: '#A19D97',
            500: '#817A74',
            600: '#484441',
            700: '#23201F',
            800: '#000000',
            900: '#191516',
            950: '#161314'
        },
        aurora: {
            50: '#CCD6E0',
            100: '#CAD3E3',
            200: '#D1D2D6',
            300: '#A9ABB1',
            400: '#979AA1',
            500: '#747B81',
            600: '#414648',
            700: '#1F2223',
            800: '#000000',
            900: '#092A34',
            950: '#031C26'
        },
        negro: {
            50: '#E3DAD8',
            100: '#E5DAD2',
            200: '#D6D5D1',
            300: '#B1AFA9',
            400: '#A19C97',
            500: '#817874',
            600: '#484341',
            700: '#231F1F',
            800: '#000000',
            900: '#1B140E',
            950: '#191006'
        },
        hell: {
            50: '#E3D8D8',
            100: '#E5D2D2',
            200: '#D6D4D1',
            300: '#B1ACA9',
            400: '#A19897',
            500: '#817474',
            600: '#484143',
            700: '#231F21',
            800: '#000000',
            900: '#1B0E0E',
            950: '#190606'
        }
    } as any
});